import React, { useState, useEffect } from "react";
import { Chart } from "primereact/chart";
import dashboardService from "../../services/dashboard-service";
import GlobalVariable from "../../services/globalVar";
import { Calendar } from "primereact/calendar";
import { BlockUI } from "primereact/blockui";
import { ProgressSpinner } from "primereact/progressspinner";
import { FaRegBell } from "react-icons/fa";

const Overalldashboard = () => {
  const ds = new dashboardService();
  //     useEffect(() => {
  //   return () => {
  //     Object.values(ds.controllers).forEach((c) => c.abort());
  //     ds.controllers = {}; 
  //   };
  // }, []);
  const currency = GlobalVariable.userDet.tenantConfig.currency;
  const [accountName, setAccountName] = useState([]);
  const [actualBudget, setActualBudget] = useState([]);
  const [financialSummaryLeft, setFinancialSummaryLeft] = useState([]);
  const [year, setYear] = useState(new Date());
  const [chartOptions2, setChartOptions2] = useState({});
  const [chartData, setChartData] = useState({});
  const [chartData2, setChartData2] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const [chartOptions4, setChartOptions4] = useState({});
  const [isProcess, setIsProcess] = useState(false);
  const [getReminderDats, setGetReminderDats] = useState([]);

  const GetPettyChashSplineChart = () => {
    setIsProcess(true);
    ds.GetPettyChashSplineChart(GlobalVariable.userDet.tenantDetail.tenantID)
      .then((res) => {
        setIsProcess(false);
        setChartData2(res.data);
        const options = {
          maintainAspectRatio: false,
          aspectRatio: 0.6,
          plugins: {
            legend: {
              labels: {
                color: "black",
              },
            },
          },
          scales: {
            x: {
              ticks: {
                color: "black",
              },
              grid: {
                color: "#E5E5E5",
              },
            },
            y: {
              ticks: {
                color: "black",
              },
              grid: {
                color: "#E5E5E5",
              },
            },
          },
        };
        setChartOptions4(options);
      })
      .catch((err) => setIsProcess(false));
  };

  const GetBudgetBarcart = (item) => {
    setIsProcess(true);
    ds.GetBudgetBarcart(
      GlobalVariable.userDet.tenantDetail.tenantID,
      item.year,
      item.month
    )
      .then((res) => {
        setIsProcess(false);
        setAccountName(res.data.data);
      })
      .catch((err) => setIsProcess(false));
  };

  const GetDashboardReportCards = () => {
    setIsProcess(true);
    ds.GetDashboardReportCards(GlobalVariable.userDet.tenantDetail.tenantID)
      .then((res) => {
        setIsProcess(false);
        setFinancialSummaryLeft(res.data.data);
      })
      .catch((err) => setIsProcess(false));
  };



  const GetProfitAndLossBarChart = () => {
    setIsProcess(true);
    ds.GetProfitAndLossBarChart(GlobalVariable.userDet.tenantDetail.tenantID)
      .then((res) => {
        setIsProcess(false);
        setChartData(res.data);
      })
      .catch((err) => setIsProcess(false));
    const options = {
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      plugins: {
        legend: {
          labels: {
            color: "blcak",
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: "black",
          },
          grid: {
            color: "#E5E5E5",
          },
        },
        y: {
          ticks: {
            color: "black",
          },
          grid: {
            color: "#E5E5E5",
          },
        },
      },
    };
    setChartOptions(options);
  };

  const GetHomeBudgetBarChart = (item) => {
    setIsProcess(true);
    ds.GetHomeBudgetBarChart(
      GlobalVariable.userDet.tenantDetail.tenantID,
      item.month,
      item.year
    )
      .then((res) => {
        setIsProcess(false);
        setActualBudget(res.data);
      })
      .catch((err) => setIsProcess(false));
    const options = {
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      plugins: {
        legend: {
          labels: {
            color: "black",
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: "black",
          },
          grid: {
            color: "#E5E5E5",
          },
        },
        y: {
          ticks: {
            color: "black",
          },
          grid: {
            color: "#E5E5E5",
          },
        },
      },
    };
    setChartOptions2(options);
  };

  const handleSelectDate = (e) => {
    const month = (e.value.getMonth() + 1).toString().padStart(2, "0");
    const year = e.value.getFullYear();
    const formattedDate = { month, year };
    GetBudgetBarcart(formattedDate);
  };

  const handleSelectYear = (e) => {
    const selectedDate = e.value;
    const selectedYear = selectedDate.getFullYear();
    const selectedMonth = (selectedDate.getMonth() + 1)
      .toString()
      .padStart(2, "0");
    const formattedDate = { month: selectedMonth, year: selectedYear };
    GetHomeBudgetBarChart(formattedDate);
    setYear(e.value);
  };

  const GetReminder = () => {
    setIsProcess(true);
    const datas = {
      Status: "",
      UserID: GlobalVariable.userDet.appUser.appuserID,
      TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
    };
    ds.GetReminder(datas)
      .then((res) => {
        setIsProcess(false);
        setGetReminderDats(res.data.data);
      })
      .catch((err) => setIsProcess(false));
  };
 
  const getCardBackgroundColor = (cardName) => {
    const colors = {
      "Total Income": "linear-gradient(45deg, rgb(250 161 176) 0%, rgb(255 199 199 / 94%) 100%)",
      "Total Expenses": "linear-gradient(270deg, rgb(91 196 164 / 57%) 0%, rgb(102 204 204) 100%)",
      "Cash at end of Month": "linear-gradient(135deg, rgb(158 135 245 / 83%) 0%, rgb(209 172 255 / 73%) 100%)",
      "Accounts Receivable": "linear-gradient(90deg, rgb(255 168 138 / 84%) 0%, rgb(255 207 159 / 69%) 100%)",
      "Accounts Payable": "linear-gradient(270deg, rgb(174 203 250 / 66%) 0%, rgb(138 180 248 / 97%) 100%)",
    };
  
    return colors[cardName] || "#ffffff"; 
  };
  
  
  useEffect(() => {
    const month = (new Date().getMonth() + 1).toString().padStart(2, "0");
    const year = new Date().getFullYear();
    const formattedDate = { month, year };
    GetBudgetBarcart(formattedDate);
    GetHomeBudgetBarChart(formattedDate);
    GetPettyChashSplineChart();
    GetDashboardReportCards();
    GetProfitAndLossBarChart();
    GetReminder();
  }, []);

  return (
    <>
      <BlockUI blocked={isProcess}>
        <div className="row">
          <div className="col-md">
            <div className="row mb-3">
              {financialSummaryLeft.map((item,index) => {
                const getIcon = (cardName) => {
                  switch (cardName) {
                    case "Total Income":
                      return (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="74"
                          height="74"
                          fill="currentColor"
                          className="bi bi-cash-coin"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0z"
                          />
                          <path d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1h-.003zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195l.054.012z" />
                          <path d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083c.058-.344.145-.678.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1H1z" />
                          <path d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 5.982 5.982 0 0 1 3.13-1.567z" />
                        </svg>
                      );
                    case "Totoal Expenses":
                      return (
                        <i
                          className="pi pi-chart-pie"
                          style={{ fontSize: "1.5rem" }}
                        ></i>
                      );
                    case "Cash at end of Month":
                      return (
                        <i
                          className="pi pi-chart-pie"
                          style={{ fontSize: "1.5rem" }}
                        ></i>
                      );
                    case "Accounts Receivable":
                      return (
                        <svg
                          width="74"
                          height="74"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.5 13.75C9.5 14.72 10.25 15.5 11.17 15.5H13.05C13.85 15.5 14.5 14.82 14.5 13.97C14.5 13.06 14.1 12.73 13.51 12.52L10.5 11.47C9.91 11.26 9.51001 10.94 9.51001 10.02C9.51001 9.17999 10.16 8.48999 10.96 8.48999H12.84C13.76 8.48999 14.51 9.26999 14.51 10.24"
                            stroke="#292D32"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12 7.5V16.5"
                            stroke="#292D32"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M17 3V7H21"
                            stroke="#292D32"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M22 2L17 7"
                            stroke="#292D32"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12 2C6.48 2 2 6.48 2 12C2 15.94 4.28001 19.35 7.60001 20.98"
                            stroke="#292D32"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M22 12C22 17.52 17.52 22 12 22"
                            stroke="#292D32"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      );
                    case "Accounts Payable":
                      return (
                        <svg
                          width="74"
                          height="74"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.5 2C3.67157 2 3 2.67157 3 3.5V16.5C3 17.3284 3.67157 18 4.5 18H11.5C12.3284 18 13 17.3284 13 16.5V15C13 14.7238 12.776 14.4998 12.4999 14.4998C12.0866 14.4998 11.8226 14.398 11.6437 14.2639C11.4612 14.127 11.322 13.9223 11.2199 13.6414C11.0059 13.053 10.9999 12.2742 10.9999 11.4997C10.9998 11.3671 10.9472 11.24 10.8534 11.1462L10.5666 10.8593C10.4578 10.7504 10.3251 10.6176 9.35356 9.64618C8.88667 9.17934 8.75014 8.86588 8.72435 8.69089C8.70385 8.55183 8.74583 8.45651 8.84563 8.361C9.06033 8.15555 9.21264 8.01659 9.38518 7.97463C9.48906 7.94937 9.72441 7.93132 10.1465 8.35333L13.1464 11.3533C13.3417 11.5486 13.6583 11.5486 13.8536 11.3533C14.0488 11.158 14.0488 10.8415 13.8536 10.6462L13 9.79263V6.70711L15.5607 9.26777C15.842 9.54907 16 9.9306 16 10.3284V17.5C16 17.7761 16.2239 18 16.5 18C16.7761 18 17 17.7761 17 17.5V10.3284C17 9.66539 16.7366 9.0295 16.2678 8.56066L13 5.29289V3.5C13 2.67157 12.3284 2 11.5 2H4.5ZM12 5.49951C12 5.49984 12 5.49918 12 5.49951V8.79264L10.8535 7.64618C10.2755 7.06823 9.7003 6.86887 9.14891 7.00294C9.03719 7.03011 8.9327 7.07032 8.83605 7.11804C8.57067 7.04119 8.29015 7 8 7C6.34315 7 5 8.34315 5 10C5 11.6569 6.34315 13 8 13C8.77173 13 9.47541 12.7086 10.007 12.2298C10.0241 12.8077 10.0824 13.4395 10.2801 13.9831C10.4279 14.3897 10.6637 14.7788 11.0437 15.0638L11.0501 15.0686C10.4415 15.2597 10 15.8283 10 16.5V17H6V16.5C6 15.6716 5.32843 15 4.5 15H4V5H4.5C5.32843 5 6 4.32843 6 3.5V3H10V3.5C10 4.32843 10.6716 5 11.5 5H12V5.49951ZM11.9999 16.4998L11.9999 16.5086C11.9953 16.7808 11.7733 17 11.5 17H11V16.5C11 16.2239 11.2239 16 11.5 16H11.9999V16.4998ZM6 10C6 8.93775 6.82814 8.06891 7.87401 8.0039C7.75028 8.23482 7.68743 8.51371 7.73503 8.8367C7.80612 9.31904 8.11334 9.82022 8.6465 10.3533L9.55324 11.26C9.18654 11.7115 8.62696 12 8 12C6.89543 12 6 11.1046 6 10ZM5 3V3.5C5 3.77614 4.77614 4 4.5 4H4V3.5C4 3.22386 4.22386 3 4.5 3H5ZM4 16H4.5C4.77614 16 5 16.2239 5 16.5V17H4.5C4.22386 17 4 16.7761 4 16.5V16ZM12 4H11.5C11.2239 4 11 3.77614 11 3.5V3H11.5C11.7761 3 12 3.22386 12 3.5V4Z"
                            fill="#212121"
                          />
                        </svg>
                      );
                    default:
                      return (
                        <i
                          className="pi pi-info-circle"
                          style={{ fontSize: "1.5rem" }}
                        ></i>
                      );
                  }
                };

                const getIconStyle = (cardName) => {
                  switch (cardName) {
                    case "Total Income":
                      return { backgroundColor: "white", color: "#FCB7BE" };
                    case "Totoal Expenses":
                      return { backgroundColor: "white", color: "#70CFCC" };
                    case "Cash at end of Month":
                      return { backgroundColor: "white", color: "#BCA7F8" };
                    case "Accounts Receivable":
                      return { backgroundColor: "white", color: "#1976d2" };
                    case "Accounts Payable":
                      return { backgroundColor: "white", color: "#1976d2" };
                    default:
                      return { backgroundColor: "white", color: "#A4C4F9" };
                  }
                };

                return (
                 
                  <div key={item.id || index} className="col-md">
                    <div
                      className="border-1 shadow-sm p-3 d-flex flex-row justify-content-between align-items-center"
                      style={{
                        background: getCardBackgroundColor(item.cardName),
                        padding: "16px",
                        borderRadius: "8px",
                      }}
                    >
                      <div>
                        <strong style={{color:"white"}}>{item.cardName}</strong>
                        <p
                          className={`fs-6 all-dashboard-leftSum ${
                            item.amount < 0 ? "white" : "white"
                          }`}
                        >
                          Amount: {currency + " " + item.amount.toFixed(2)}
                        </p>
                      </div>
                      <div
                        className="icon-container d-flex justify-content-center align-items-center"
                        style={{
                          ...getIconStyle(item.cardName),
                          borderRadius: "50%",
                          padding: "10px",
                          width: "45px",
                          height: "45px",
                        }}
                      >
                        {getIcon(item.cardName)}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="col-sm-12 mb-3">
          <div className="row mx-auto d-flex gap-2">
            
            <div className="col-sm-8 p-0" style={{ height: "100%" }}>
              <div className="card p-3 border-0 card-box ">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h4>Actual & Budgeting</h4>
                  <div style={{ visibility: "hidden" }}>
                    <Calendar
                      view="year"
                      placeholder="Select year"
                      dateFormat="yy"
                      value={year}
                      onChange={(e) => handleSelectYear(e)}
                      style={{ width: "92px" }}
                    />
                  </div>
                </div>
                <Chart
                  type="bar"
                  data={actualBudget.data}
                  options={chartOptions2}
                  style={{ height: "286Px" }}
                />
              </div>
            </div>
            <div className="col-sm p-0 ">
              <div
                className="p-3 card border-0 card-box"
                style={{
                  borderRadius: "5px",
                  backgroundColor: "#f9f9f9",
                  height: "370px",
                }}
              >
                <div
                  className="d-flex justify-content-between align-items-center"
                  // style={{
                  //   borderBottom: "1px solid #ddd",
                  // }}
                >
                  <h4>Reminders</h4>
                </div>
                <div
                  style={{
                    overflowY: "scroll",
                    height: "300px",
                    position: "relative",
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    padding: "10px",
                    // boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  {getReminderDats.length === 0 ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "100%", color: "#888" }}
                    >
                      <p>No reminders available</p>
                    </div>
                  ) : (
                    <div
                    // className="scrolling-content"
                    // style={{
                    //   animation: "scroll-up 20s linear infinite",
                    // }}
                    >
                      {getReminderDats.map((a, i) => {
                        const dateObj = new Date(a.endDateTime);
                        const formattedDate = `${String(
                          dateObj.getDate()
                        ).padStart(2, "0")}/${String(
                          dateObj.getMonth() + 1
                        ).padStart(2, "0")}/${dateObj.getFullYear()}`;

                        return (
                          <div
                            key={i}
                            className="p-2 mb-2"
                            style={{
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            <p
                              className="m-0"
                              style={{
                                fontSize: "14px",
                                color: "#333",
                                lineHeight: "1.4",
                              }}
                            >
                              <strong style={{ color: "#007bff" }}>
                                                        <FaRegBell size="15" className="me-2"/>
                                {a.title} 
                              </strong> ({new Date(a.startDateTime).toLocaleDateString()} -{" "}
                              {new Date(a.endDateTime).toLocaleDateString()})
                              : <br />
                               {a.detailDescription}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row ">
          <div className="col-sm-6">
            <div className="card border-0 card-box p-3">
              <Chart
                style={{ height: "290px" }}
                type="bar"
                data={chartData.data}
                options={chartOptions}
              />
            </div>
          </div>

          <div className="col-sm-6 ps-0">
            <div className="row mx-auto d-flex gap-2">
              <div className="card p-3 border-0 card-box ">
                <div id="chart-timeline" style={{ height: "18rem" }}>
                  <Chart
                    type="line"
                    width="400"
                    data={chartData2.data}
                    options={chartOptions4}
                    style={{ height: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

               
        {isProcess && (
          <ProgressSpinner
            style={{
              width: "50px",
              height: "50px",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
            strokeWidth="2"
            fill="var(--surface-ground)"
            animationDuration=".5s"
          />
        )}
      </BlockUI>
    </>
  );
};

export default Overalldashboard;
